<app-master-data-table [data]="masterCommonService.quotationCloseReasonsList" [columns]="quotationclosereasonColumns"
  title="Quotation Close Reasons List" addButtonLabel="Quotation Close Reason"
  (add)="openAddUpdateQuotationCloseReasonDialog('add')"
  (update)="openAddUpdateQuotationCloseReasonDialog('update', $event)" (delete)="deleteQuotationCloseReason($event)">
</app-master-data-table>